import { Modal } from 'react-bootstrap';
import { OpoModalButtons } from '../opo-styles';

interface IProps {
    show: boolean,
    title: string,
    message: JSX.Element,
    confirmText: string,
    onConfirm: () => void,
    onCancel: () => void
}

const ConfirmModal = ({ show, title, message, confirmText, onConfirm, onCancel }: IProps) => (
    <Modal show={show} onHide={onCancel}>
        <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>
            <OpoModalButtons>
                <button type='button' className='btn btn-danger' onClick={onConfirm}>{confirmText}</button>
                <button type='button' className='btn' onClick={onCancel}>Cancel</button>
            </OpoModalButtons>
        </Modal.Footer>
    </Modal>
);

export default ConfirmModal;
